'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchBarDirective = undefined;

var _searchBarDir = require('./search-bar.dir.scss');

var _searchBarDir2 = _interopRequireDefault(_searchBarDir);

var _searchBarDir3 = require('./search-bar.dir.html');

var _searchBarDir4 = _interopRequireDefault(_searchBarDir3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchBarDirective = exports.SearchBarDirective = {
  template: _searchBarDir4.default,
  selector: 'searchBar',
  scope: {
    placeholderText: '=',
    searchFilter: '='
  },
  replace: true,
  restrict: 'E'
};


//////////////////
// WEBPACK FOOTER
// ./common/directives/search-bar/search-bar.dir.js
// module id = 473
// module chunks = 0